import React from 'react';
import './sass/App.scss';
import {withRouter, Switch, Route} from "react-router-dom";
const PDP = React.lazy(() => import('./components/PDP' /* webpackChunkName: "PDP" */));
const PLP = React.lazy(() => import('./components/PLP' /* webpackChunkName: "PLP" */));
const Designers = React.lazy(() => import('./components/Designers' /* webpackChunkName: "Designers" */));
const GC = React.lazy(() => import('./components/PDP/GC' /* webpackChunkName: "GC" */));
import { shallowEqual, useSelector } from "react-redux"

const BuyingSection = ({ is_gift_card_product }) => {
    const { mobileBig, mobile, mobileSmall } = useSelector(
        (state) => ({
            mobileBig: state.appReducer.desktop_small,
            mobile: state.appReducer.mobile_big,
            mobileSmall: state.appReducer.mobile_small,
        }),
        shallowEqual
    );

    return (
        <div className='buying-section'>
            <Switch>
                <Route path='/products/:handle/:variant'>
                    <GC mobile={mobile} mobileSmall={mobileSmall} mobileBig={mobileBig} />
                </Route>
                <Route path='/products/:handle'>
                    {is_gift_card_product ? (
                        <GC mobile={mobile} mobileSmall={mobileSmall} mobileBig={mobileBig} />
                    ) : (
                        <PDP mobile={mobile} mobileSmall={mobileSmall} mobileBig={mobileBig} />
                    )}
                </Route>
                <Route path='/:lang/products/:handle/:variant'>
                    <GC mobile={mobile} mobileSmall={mobileSmall} mobileBig={mobileBig} />
                </Route>
                <Route path='/:lang/products/:handle'>
                    {is_gift_card_product ? (
                      <GC mobile={mobile} mobileSmall={mobileSmall} mobileBig={mobileBig} />
                    ) : (
                      <PDP mobile={mobile} mobileSmall={mobileSmall} mobileBig={mobileBig} />
                    )}
                </Route>
                <Route exact path='/collections/:col/products/:handle'>
                    <PDP mobile={mobile} mobileSmall={mobileSmall} mobileBig={mobileBig} />
                </Route>
                <Route exact path='/collections/:col'>
                    <PLP />
                </Route>
                <Route exact path='/:lang/collections/:col'>
                    <PLP />
                </Route>
                <Route exact path='/search'>
                    <PLP />
                </Route>
                <Route exact path='/collections'>
                    <Designers />
                </Route>
            </Switch>
        </div>
    );
};

export default withRouter(BuyingSection);
